import { useCountries } from './useCountries'

function useCountryName() {
  const { data, isLoading } = useCountries()

  return {
    getCountryName: (countryId: string) => {
      if (isLoading) return ''
      return (
        data?.find((country) => country._id === countryId)?.native ?? countryId
      )
    },
    isLoading,
  }
}

export { useCountryName }
